import { LicenseException } from '@/domain/licensing/exception/LicenseException'

export class UnauthorizedException extends LicenseException
{

}
